module.exports = require('../_components/@alicd/next-number-picker/lib/index.js');


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next@0.19.78@@alicd/next/lib/number-picker/index.js
// module id = 653
// module chunks = 0